// Spinner.tsx

import React, { memo } from 'react';
import { CircularProgress } from "@heroui/react";
import './Spinner.css';

interface ISpinnerProps {
    isBusy: boolean;
    size?: 'sm' | 'md' | 'lg';
    label?: string;
    colorClass?: string;
    textSize?: 'text-medium' | 'text-lg' | 'text-xl' | 'text-small' | 'text-xs';
}

const SharedSpinner: React.FC<ISpinnerProps> = ({ label = '', size = "sm", textSize = "text-small", isBusy, colorClass = "text-msi-midblue-color-900" }) => {
    return (
        isBusy ? (
            <div className="spinner-overlay inset-0">
                <CircularProgress size={size} label={label} classNames={{
                    label: `font-medium text-medium ${colorClass} ${textSize}`,
                    indicator: `${colorClass}`,
                }} />
            </div>
        ) : null
    );
};

export default memo(SharedSpinner);
